import { ThemeProvider } from "@mui/material";
import React from "react";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import store from "./application/store";
import AppRouter from "./presentation/AppRouter";
import "./presentation/assets/fonts/dana/Farsi numerals/Webfonts/css/fontiran.css";
import "./presentation/assets/style/index.scss";
import theme from "./presentation/common/theme";
import RTL from "./presentation/common/theme/CacheProvider";
import reportWebVitals from "./reportWebVitals";
import { startAppVersionMonitor } from "./infrastructure/utils/appVersionMonitor";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <RTL>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <ToastContainer position={toast.POSITION.BOTTOM_LEFT} />
          <AppRouter />
        </Provider>
      </ThemeProvider>
    </RTL>
  </React.StrictMode>
);

startAppVersionMonitor();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
